/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Aug 02 2024
 **/

import { useQuery } from "@tanstack/react-query";

const useQueryCache = <T>(queryKey: string[]) => {
	const { data } = useQuery<T>({
		queryKey,
		staleTime: Infinity,
		enabled: true
	});

	return data;
};

export type FriendListMap = Map<string, WebServices.Friend.Friends.Item>;
export type BlockListMap = Map<string, WebServices.Block.List.Item>;

/**
 * 친구 리스트 조회하는 훅
 */
export const useFriendListState = () => {
	const friendListMap = useQueryCache<FriendListMap>(["getFriendList"]);
	return friendListMap;
};

/**
 * 친구 리스트의 유저 조회하는 훅
 */
export const useFriendUserState = ({ userID }: { userID: string }) => {
	const friendListMap = useQueryCache<FriendListMap>(["getFriendList"]);
	const user = friendListMap?.get(userID);
	return user;
};

/**
 * 차단 리스트 조회하는 훅
 */
export const useBlockListState = () => {
	const blockListMap = useQueryCache<BlockListMap>(["getBlockUserList"]);
	return blockListMap;
};
